export default class LayoutController {
  constructor($rootScope, AuthenticationService, AuthorizationService, $state, UIService) {

    this.AuthenticationService = AuthenticationService;
    this.AuthorizationService = AuthorizationService;
    this.$state = $state;
    this.UI = UIService;

    $rootScope.$on('$receivedServerStatus', (evt, data) => {
      this.status = data;
      $rootScope.status = data;
    });

    this.menuItems = [];

    this.user = AuthenticationService.getUser();

    this.isAuthenticated = () => {
      AuthenticationService.isAuthenticated();
    };

    this.parseMenu();
  }

  logout = () => {
    this.AuthenticationService.logout();
  };

  parseMenu = () => {
    const jsonMenu = require('../sidenav.json');
    // Getting list of all states, so that role will be loaded from states...
    let states = this.$state.get();
    states = _.filter(states, s => {
      // Ignore abstract routes and placeholders
      return s.hasOwnProperty('template') && s.hasOwnProperty('controller');
    });

    // Iterate the sidebar options through the states, to get the required role for it
    let menu = [];
    jsonMenu.forEach(section => {
      if (section.hasOwnProperty('investigadorOnly') && section.investigadorOnly === true) {
        if (this.user.investigador && this.user.investigador.id > 0) {
          section.state += `({id: ${this.user.investigador.id}})`;
          menu.push(section);
        }
      } else if (section.hasOwnProperty('sections')) {
        let k = [];
        section.sections.forEach(o => {
          let s = _.find(states, {name: o.state});
          if (angular.isDefined(s)) {
            if (s.hasOwnProperty('role')) {
              if (this.AuthorizationService.canPerform(s.role)) {
                if (o.hasOwnProperty('params')) {
                  o.state += `(${JSON.stringify(o.params)})`;
                }
                k.push(o);
              }
            } else {
              if (o.hasOwnProperty('params')) {
                o.state += `(${JSON.stringify(o.params)})`;
              }
              k.push(o);
            }
          } else {
            // Do nothing... :)
          }
        });
        if (k.length > 0) {
          section.sections = k;
          menu.push(section);
        }
      } else {
        let s = _.find(states, {name: section.state});
        if (angular.isDefined(s)) {
          if (s.hasOwnProperty('role')) {
            if (this.AuthorizationService.canPerform(s.role)) {
              if (section.hasOwnProperty('params')) {
                section.state += `(${JSON.stringify(section.params)})`;
              }
              menu.push(section);
            }
          } else {
            if (section.hasOwnProperty('params')) {
              section.state += `(${JSON.stringify(section.params)})`;
            }
            menu.push(section);
          }
        } else {
          // Do nothing... :)
        }
      }
    });
    this.menuItems = menu;
  };

  // Check if state is active or not
  // To revert, replace in the view this function line with
  // <a ng-if="!menu.sections" class="pmd-ripple-effect" ui-sref="{{menu.state}}" ui-sref-active="active"
  // Return true if state is a substate of the current state
  isActiveState = (state) => {
    // Account special case for 'O Meu Perfil' - do not show Investigadores when it's own profile

    if (this.$state.current.name === 'app.investigator.list') {
      return state === this.$state.current.name;
    }

    if (this.$state.current.name ===  'app.investigator.details') {
      // If it's 'O Meu Perfil'
      if (this.user && this.user.investigador && this.user.investigador.id === Number(this.$state.params.id)) {
        return state.startsWith(this.$state.current.name); // because state has details({id: ...}) in the string
      } else { // Any other details, highlight app.investigator.list only
        return state.startsWith('app.investigator.list');
      }
    }
    // All other cases
    return state.substr(0, state.lastIndexOf('.')) === this.$state.current.name.substr(0, this.$state.current.name.lastIndexOf('.'));
  }

  // Highlight section if current state is selected
  isActiveSection = (sections) => {
    if (sections && sections.length > 0) {
      for (let i = 0; i < sections.length; i++) {
        if (this.$state.current.name === sections[i].state)
          return true;
        // Special 'app.administration' case
        if (this.$state.current.name.startsWith('app.administration') && sections[i].state.startsWith('app.administration'))
          return true;
      }
    }
    return false;
  }

}

LayoutController.$inject = ['$rootScope', 'AuthenticationService', 'AuthorizationService', '$state', 'UIService'];
